import { NgModule, ModuleWithProviders } from '@angular/core'
import { CommonModule } from '@angular/common'
import { IcosSwitch } from './switch'
import { FormsModule } from '@angular/forms'


@NgModule({
  declarations: [IcosSwitch],
  exports: [IcosSwitch],
  imports: [CommonModule, FormsModule],
  entryComponents: [IcosSwitch],
})
export class IcosSwitchModule {
  static forRoot(): ModuleWithProviders {
    return { ngModule: IcosSwitchModule, providers: [] }
  }
}
